import actions from "./agent-actions";
import getters from "./agent-getters";
import mutations from "./agent-mutations";
const AgentsStore = {
  namespaced: true,
  state: {
    agents: {
      byId: {},
      allIds: []
    }
  },
  mutations,
  actions,
  getters
};
export default AgentsStore;